import React, { ReactNode } from 'react';

import { APButton } from '@astropay/web-core-library';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, Dialog, DialogActions, DialogContent, DialogTitle, Slide } from '@material-ui/core';
import { TransitionProps } from '@material-ui/core/transitions';
import classnames from 'classnames';

import ApIconButton from '../forms/ap-icon-button';
import { PageWithActionProps } from '../layouts/page-with-action';
import Loading from '../loading/loading';
import { useApBottomSheetStyles } from './styles';

export interface ApBottomSheetProps extends PageWithActionProps {
  isOpen: boolean;
  onClose?: () => void;
  hideCloseAction?: boolean;
  bottomContent?: ReactNode;
  fullHeight?: boolean;
}
const Transition = React.forwardRef(function Transition(
  //eslint-disable-next-line
  props: TransitionProps & { children?: React.ReactElement<any, any> },
  ref: React.Ref<unknown>,
) {
  return (
    <Slide direction="up" ref={ref} {...props} timeout={300} mountOnEnter unmountOnExit></Slide>
  );
});

const ApBottomSheet: React.FC<ApBottomSheetProps> = ({
  isOpen,
  onClose,
  hideCloseAction = false,
  title,
  children,
  primaryAction,
  secondaryAction,
  bottomContent,
  bottomDescription,
  topDescription,
  isLoading,
  forceOverflow,
  fullHeight,
}) => {
  const classes = useApBottomSheetStyles();
  const hasActions = !!primaryAction || !!secondaryAction;

  return (
    <Dialog
      TransitionComponent={Transition}
      classes={{
        container: classes.root,
        paper: classnames(classes.paper),
      }}
      onClose={onClose}
      open={isOpen}
      fullWidth
    >
      {isLoading ? (
        <Loading />
      ) : (
        <>
          {onClose && !hideCloseAction && (
            <ApIconButton className={classes.closeIcon} onClick={onClose}>
              <FontAwesomeIcon icon={['far', 'times']} />
            </ApIconButton>
          )}
          {title && <DialogTitle>{title}</DialogTitle>}

          <DialogContent
            classes={{ root: classnames(classes.contentRoot, { fullHeight: fullHeight }) }}
            className={forceOverflow ? 'overflow' : 'noOverflow'}
          >
            {children}
          </DialogContent>

          <Box>
            {bottomContent && (
              <Box component="div" className={classes.bottomContent}>
                {bottomContent}
              </Box>
            )}
            {hasActions && (
              <DialogActions disableSpacing classes={{ root: classes.actionsRoot }}>
                {topDescription && <Box className={classes.topDescription}>{topDescription}</Box>}

                {primaryAction && (
                  <APButton
                    variant="flat"
                    id={primaryAction.id ?? 'btn-primary-bs'}
                    classes={{ root: classes.buttonRoot }}
                    onClick={primaryAction.action}
                    disabled={primaryAction.disabled}
                    size="large"
                  >
                    {primaryAction.text}
                  </APButton>
                )}
                {secondaryAction && (
                  <APButton
                    color="secondary"
                    variant="text"
                    id={secondaryAction.id ?? 'btn-secondary-bs'}
                    classes={{ root: classes.buttonRoot }}
                    onClick={secondaryAction.action}
                    disabled={secondaryAction.disabled}
                    size="large"
                  >
                    {secondaryAction.text}
                  </APButton>
                )}
              </DialogActions>
            )}
            {bottomDescription && (
              <Box className={classes.bottomDescription}>{bottomDescription}</Box>
            )}
          </Box>
        </>
      )}
    </Dialog>
  );
};

export default ApBottomSheet;
